import { Button, HeadingSection, VFlow } from 'bold-ui'
import { useErrorHandler } from 'components/error'
import { useTesteEnvioProfissionaisMutation, useTesteSaveProfissionaisMutation } from 'graphql/hooks.generated'
import React from 'react'

export const ButonsTesteUnificacaoBaseComponent = () => {
  const [envioProfissionaisMutation] = useTesteEnvioProfissionaisMutation()
  const [saveProfissionaisMutation] = useTesteSaveProfissionaisMutation()
  const handleRejection = useErrorHandler()

  const onEnviarProfissionaisClicked = () => {
    envioProfissionaisMutation().catch(handleRejection)
  }

  const onSalvarProfissionaisClicked = () => {
    saveProfissionaisMutation()
  }

  return (
    <VFlow>
      <HeadingSection level={2} title='Testes' />
      <Button size='medium' kind='primary' onClick={onEnviarProfissionaisClicked}>
        Enviar Profissionais
      </Button>
      <Button size='medium' kind='primary' onClick={onSalvarProfissionaisClicked}>
        Salvar Profissionais
      </Button>
    </VFlow>
  )
}
